<template>
  <el-card class="products" @click="onCardClick">
    <PreviewRendererImg
      :meshes="[
        {
          thumbnail: title,
          thumbnailUrl: thumbnailUrl,
        },
      ]"
    />
    <div v-if="title" class="media card-bottom">
      <span class="media-content">
        <h5 class="card-title">
          <el-tooltip
            :content="productTitle(title)"
            effect="dark"
            placement="top"
            popper-class="large-tooltip"
          >
            {{ productTitle(title) }}
          </el-tooltip>
        </h5>
      </span>
      <span v-if="showDelete" class="media-right">
        <span class="deleteModel" @click.stop="onDelete">
          <font-awesome-icon icon="trash" />
        </span>
      </span>
    </div>
  </el-card>
</template>

<script setup lang="ts">
import PreviewRendererImg from '@/components/features/previewRenderer/PreviewRendererImg.vue';
import { removeWordFromString } from '@/utils/formBuilder';

defineProps<{
  title: string;
  thumbnailUrl: string | null;
  showDelete?: boolean;
}>();

function productTitle(title: string): string {
  return removeWordFromString(title, 'phase1');
}

const emit = defineEmits(['delete', 'cardClick']);

function onDelete(e: MouseEvent) {
  emit('delete', e);
}

function onCardClick(e: MouseEvent) {
  emit('cardClick', e);
}
</script>

<style scoped lang="scss">
.products {
  transition: 250ms;
  width: 100%;
  border: 0.3rem solid #f9f9f9;
  border-radius: 10px;
  cursor: pointer;
  overflow: hidden;

  .card-bottom {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0;
    color: #1d1e19;
    padding: 0 4px;
    background-color: #f9f9f9;
  }

  .card-title {
    padding: 0.5rem;
    font-size: clamp(0.8rem, calc(2rem - 0.15rem * var(--length, 10)), 1.2rem);
    text-align: center;
    width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.deleteModel {
  width: 30px;
  display: inline-block;
  cursor: pointer;
}

:deep(.el-card__body) {
  display: grid;
  justify-content: center;
  padding: 0;

  .image{
    display: flex;
    justify-content: center;
  }
}
</style>
